<template>
  <h2>{{ $t('Vaše soukromí') }}</h2>
  <div class="RichText" v-html="getText('block3_text')"></div>
  <!-- 
  {{ currentCookies }}
  <br />
  {{ currentCookiesState }}
  <br />
  {{ x }}
  <hr /> -->

  <div class="divide-y divide-gray-200 border-t border-gray-200">
    <cookie-manager-settings-row class="py-6" v-for="c in cookieTypes" :key="c.id" :c="c" @set-checkbox="setCheckbox" />
  </div>

  <!--  @click="setState(4), $store.dispatch('tinyModal/close')" -->
  <p class="flex flex-wrap items-center justify-center gap-5 mt-8">
    <button
      @click="
        save(
          cookieTypes.map(c => c.identifier),
          'ACCEPT_ALL',
          4
        ),
          $store.dispatch('tinyModal/close')
      "
      class="CookieManager__Button"
    >
      {{ $t('Přijmout vše') }}
    </button>
    <button
      @click="save(tempCookies, 'ACCEPT_PARTIALLY', 4), $store.dispatch('tinyModal/close')"
      class="CookieManager__Button"
    >
      {{ $t('Přijmout vybrané') }}
    </button>
    <button @click="save(['stricly'], 'DENY_ALL', 4), $store.dispatch('tinyModal/close')" class="CookieManager__Button">
      {{ $t('Nepřijmout nic') }}
    </button>
  </p>
</template>

<script>
export default {
  props: ['cookieTypes'],
  inject: [
    'getText',
    'setAppState',
    'currentCookies',
    'currentCookiesState',
    'saveCookies',
    'saveCookiesState',
    'save'
  ],
  data() {
    return {
      tempCookies: []
    }
  },
  methods: {
    setCheckbox(cookieName, bool) {
      // add to
      if (bool && !this.tempCookies.includes(cookieName)) {
        this.tempCookies.push(cookieName)
      }
      // remove
      else {
        let index = this.tempCookies.indexOf(cookieName)
        if (index !== -1) {
          this.tempCookies.splice(index, 1)
        }
      }
    }
  },
  mounted() {
    this.tempCookies = [...this.currentCookies.value]
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/components/_cookie-manager.scss';
</style>
